


export default function dropdownTabs() {
  try {
    // Only work on desktop resolution (>= 1200px)
    if (window.innerWidth < 1200) return;

    const allDropdownsWithTabs = document.querySelectorAll(".dropdown--with-tabs");

    allDropdownsWithTabs.forEach((dropdown) => {
      const tabItems = dropdown.querySelectorAll(".dropdown__content > ul > li");

      tabItems.forEach((tabItem) => {
        tabItem.addEventListener("click", (e) => {
          // e.preventDefault();

          // Remove active class from all tabs in THIS dropdown only
          tabItems.forEach((item) => item.classList.remove("active"));

          // Add active class to clicked tab
          tabItem.classList.add("active");
        });
      });
    });
  } catch (error) {
    console.error("Dropdown tabs error:", error);
  }
}
